// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { FetchAdminOrdersApi } from "../../ApiCalls/Orders";
// import {
//   MdOutlineAccountBalanceWallet,
//   MdOutlineConfirmationNumber,
//   MdOutlineWorkHistory,
// } from "react-icons/md";
// import NoOrders from "../../assets/seller/loading.png";
// const AdminOrder = () => {
//   const [fetchedOrders, setFetchedOrders] = useState([]);
//   const [filter, setFilter] = useState(null);
//   const navigate = useNavigate();
//   useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const orders = await FetchAdminOrdersApi(filter);
//         setFetchedOrders(orders.Data);
//       } catch (error) {
//         console.log(error);
//       }
//     };
//     fetchOrders();
//   }, [filter]);

//   //filter order fetch
//   const filters = [
//     {
//       key: 1,
//       label: "All",
//       value: null,
//       icon: <MdOutlineAccountBalanceWallet />,
//     },
//     {
//       key: 2,
//       label: "Pending",
//       value: "pending",
//       icon: <MdOutlineWorkHistory />,
//     },
//     {
//       key: 3,
//       label: "Completed",
//       value: "completed",
//       icon: <MdOutlineConfirmationNumber />,
//     },
//   ];
//   // order status
//   const statusMap = {
//     0: "Pending",
//     1: "Order Confirmed",
//     2: "Shipping",
//     3: "Delivered",
//     4: "Cancelled",
//   };
//   return (
//     <div className="h-full w-full space-y-4 p-5">
//       <div className="flex w-full items-center justify-start">
//         {/* <h1 className="text-2xl font-medium">Order List</h1> */}
//         <div className="flex w-full items-center justify-around border-b bg-white p-2">
//           {filters.map((f) => (
//             <div
//               key={f.key}
//               onClick={() => setFilter(f.value)}
//               className={`flex cursor-pointer items-center gap-1 ${
//                 filter === f.value ? "font-bold text-brand-button-green-bg" : ""
//               }`}
//             >
//               {f.icon}
//               {f.label}
//             </div>
//           ))}
//         </div>
//       </div>
//       {fetchedOrders?.length > 0 ? (
//         <div className="flex w-full flex-col">
//           {/* Header */}
//           <div className="w-full">
//             <div className="grid w-full grid-cols-[4rem,2fr,2.5fr,2fr,2fr,2fr,2.5fr,1.5fr] bg-white p-2 font-medium text-brand-button-green-bg">
//               <div className="text-center">No</div>
//               <div className="text-center">Order Date</div>
//               <div className="text-center">Order No</div>
//               {/* <div className="text-center">Product Code</div> */}
//               <div className="text-center">Place</div>
//               {/* <div className="text-center">Delivery Time</div> */}
//               <div className="text-center">Total Amount</div>
//               <div className="text-center">Seller Comment</div>
//               <div className="text-center">Status</div>
//               <div className="text-center">Actions</div>
//             </div>
//           </div>
//           <div className="mt-10">
//             {/* Order Rows */}
//             {fetchedOrders.map((order, index) => (
//               <div
//                 key={order.id}
//                 className="grid grid-cols-[4rem,2fr,2.5fr,2fr,2fr,2fr,2.5fr,1.5fr] items-center gap-2 p-2"
//               >
//                 <div className="rounded border p-2 text-center">
//                   {index + 1}
//                 </div>
//                 <div className="line-clamp-1 rounded border p-2 text-center">
//                   {order.order_date}
//                 </div>
//                 <div className="line-clamp-1 rounded border p-2 text-center">
//                   {order.order_number}
//                 </div>
//                 {/* <div className="rounded border p-2 text-center">
//                   {order.product_code}
//                 </div> */}
//                 <div className="line-clamp-1 rounded border p-2 text-center">
//                   {order.place}
//                 </div>
//                 {/* <div className="rounded border p-2 text-center">
//                 {order.delivery_time}
//               </div> */}
//                 <div className="line-clamp-1 rounded border p-2 text-center">
//                   ₹ {order.total_amount}
//                 </div>
//                 <div className="line-clamp-1 rounded border p-2 text-center">
//                   {order.seller_comment || "No comment"}
//                 </div>
//                 <div className="rounded border p-2 text-center">
//                   {order.order_status || "Unknown Status"}
//                 </div>
//                 <div className="flex justify-center gap-2">
//                   <button
//                     onClick={() =>
//                       navigate(
//                         `/admin/orders/view_order/${order.order_number}`,
//                       )
//                     }
//                     className="rounded-md bg-brand-button-green-bg p-2 px-4 text-white"
//                   >
//                     View
//                   </button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       ) : (
//         <div className="flex h-[90%] w-full flex-col items-center justify-center">
//           <img
//             src={NoOrders}
//             alt="No orders found"
//             className="h-auto w-52 object-cover"
//           />
//           <h2 className="mt-2 text-2xl font-medium">No orders found</h2>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdminOrder;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FetchAdminOrdersApi,
  FetchSubAdminOrdersApi,
} from "../../ApiCalls/Orders";
import {
  MdOutlineAccountBalanceWallet,
  MdOutlineConfirmationNumber,
  MdOutlineWorkHistory,
} from "react-icons/md";
import NoOrders from "../../assets/seller/loading.png";
import { useAuth } from "../../context/AuthContext";

const AdminOrder = () => {
  const [fetchedOrders, setFetchedOrders] = useState([]);
  const [filter, setFilter] = useState(null);
  const navigate = useNavigate();
  const { user } = useAuth();
  useEffect(() => {
    console.log(user);
    const fetchOrders = async () => {
      try {
        if (user.user_type === "subadmin") {
          const orders = await FetchSubAdminOrdersApi(filter);
          setFetchedOrders(orders.Data);
        } else {
          const orders = await FetchAdminOrdersApi(filter);
          setFetchedOrders(orders.Data);
        }
        // const orders = await FetchAdminOrdersApi(filter);
        // setFetchedOrders(orders.Data);
      } catch (error) {
        console.log(error);
      }
    };
    fetchOrders();
  }, [filter]);

  //filter order fetch
  const filters = [
    {
      key: 1,
      label: "All",
      value: null,
      icon: <MdOutlineAccountBalanceWallet />,
    },
    {
      key: 2,
      label: "Pending",
      value: "pending",
      icon: <MdOutlineWorkHistory />,
    },
    {
      key: 3,
      label: "Completed",
      value: "completed",
      icon: <MdOutlineConfirmationNumber />,
    },
  ];

  // order status
  const statusMap = {
    0: "Pending",
    1: "Order Confirmed",
    2: "Shipping",
    3: "Delivered",
    4: "Cancelled",
  };

  return (
    <div className="h-full w-full space-y-4 p-5">
      <h1 className="text-2xl font-medium text-green-600"> Orders</h1>
      <div className="flex w-full items-center justify-start">
        <div className="flex w-full items-center justify-around border-b bg-white p-2">
          {filters.map((f) => (
            <div
              key={f.key}
              onClick={() => setFilter(f.value)}
              className={`flex cursor-pointer items-center gap-1 ${
                filter === f.value ? "font-bold text-brand-button-green-bg" : ""
              }`}
            >
              {f.icon}
              {f.label}
            </div>
          ))}
        </div>
      </div>
      {fetchedOrders?.length > 0 ? (
        <div className="flex w-full flex-col">
          {/* Header */}
          <div className="w-full">
            <div className="grid w-full grid-cols-[4rem,2fr,2.5fr,2fr,2fr,2.5fr,1.5fr] bg-white p-2 font-medium text-brand-button-green-bg">
              <div className="text-center">No</div>
              <div className="text-center">Order Date</div>
              <div className="text-center">Order No</div>
              <div className="text-center">Place</div>
              <div className="text-center">Total Amount</div>
              {/* <div className="text-center">Seller Comment</div> */}
              <div className="text-center">Status</div>
              <div className="text-center">Actions</div>
            </div>
          </div>
          <div className="mt-10">
            {/* Order Rows */}
            {fetchedOrders.map((order, index) => (
              <div
                key={order.id}
                className="grid grid-cols-[4rem,2fr,2.5fr,2fr,2fr,2.5fr,1.5fr] items-center gap-2 p-2"
              >
                <div className="rounded border p-2 text-center">
                  {index + 1}
                </div>
                <div className="line-clamp-1 rounded border p-2 text-center">
                  {order.order_date}
                </div>
                <div className="line-clamp-1 rounded border p-2 text-center">
                  {order.order_number}
                </div>
                <div className="line-clamp-1 rounded border p-2 text-center">
                  {order.place}
                </div>
                <div className="line-clamp-1 rounded border p-2 text-center">
                  ₹ {order.total_amount}
                </div>
                {/* <div className="line-clamp-1 rounded border p-2 text-center">
                  {order.seller_comment || "No comment"}
                </div> */}
                <div className="rounded border p-2 text-center">
                  {order.order_status || "Unknown Status"}
                </div>
                <div className="flex justify-center gap-2">
                  <button
                    onClick={() =>
                      user.user_type === "subadmin"
                        ? navigate(
                            `/subadmin/orders/view_order/${order.order_number}`,
                          )
                        : navigate(
                            `/admin/orders/view_order/${order.order_number}`,
                          )
                    }
                    className="flex flex-1 cursor-pointer items-center justify-center rounded-lg border border-green-600 py-2 text-center text-xs font-medium text-green-600 shadow-md transition hover:border-green-700 hover:bg-green-700 hover:text-white sm:text-sm"
                  >
                    View
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="flex h-[90%] w-full flex-col items-center justify-center">
          <img
            src={NoOrders}
            alt="No orders found"
            className="h-auto w-52 object-cover"
          />
          <h2 className="mt-2 text-2xl font-medium">No orders found</h2>
        </div>
      )}
    </div>
  );
};

export default AdminOrder;
